var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.obj)?_c('div',[_c('a-tag',{attrs:{"color":_vm.obj.color,"closable":_vm.obj.title == '占场' ? true : false},on:{"close":_vm.onClose}},[_vm._v(_vm._s(_vm.obj.title))])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }